import React from 'react';
import { motion } from 'framer-motion';
export function Settings() {
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} className="space-y-8 max-w-3xl" data-id="element-596">
      <div data-id="element-597">
        <h1 className="text-2xl font-display font-bold text-white mb-1" data-id="element-598">
          Settings
        </h1>
        <p className="text-[var(--muted)] text-sm" data-id="element-599">
          Manage event preferences and AI allocation rules.
        </p>
      </div>

      <div className="space-y-6" data-id="element-600">
        {/* Event Details */}
        <section className="bg-[var(--surface)] border border-white/5 rounded-xl p-6" data-id="element-601">
          <h2 className="text-lg font-medium text-white mb-4" data-id="element-602">Event Details</h2>
          <div className="space-y-4" data-id="element-603">
            <div data-id="element-604">
              <label className="block text-sm font-medium text-[var(--muted)] mb-1.5" data-id="element-605">
                Event Name
              </label>
              <input type="text" defaultValue="City Marathon 2026" className="w-full bg-[var(--bg)] border border-white/10 rounded-md px-3 py-2 text-white focus:outline-none focus:border-[var(--accent)]/50" data-id="element-606" />
            </div>
            <div className="grid grid-cols-2 gap-4" data-id="element-607">
              <div data-id="element-608">
                <label className="block text-sm font-medium text-[var(--muted)] mb-1.5" data-id="element-609">
                  Date
                </label>
                <input type="date" defaultValue="2026-10-15" className="w-full bg-[var(--bg)] border border-white/10 rounded-md px-3 py-2 text-white focus:outline-none focus:border-[var(--accent)]/50" data-id="element-610" />
              </div>
              <div data-id="element-611">
                <label className="block text-sm font-medium text-[var(--muted)] mb-1.5" data-id="element-612">
                  Timezone
                </label>
                <select className="w-full bg-[var(--bg)] border border-white/10 rounded-md px-3 py-2 text-white focus:outline-none focus:border-[var(--accent)]/50" data-id="element-613">
                  <option data-id="element-614">America/Los_Angeles (PST)</option>
                  <option data-id="element-615">America/New_York (EST)</option>
                </select>
              </div>
            </div>
          </div>
        </section>

        {/* AI Allocation */}
        <section className="bg-[var(--surface)] border border-white/5 rounded-xl p-6" data-id="element-616">
          <h2 className="text-lg font-medium text-white mb-4" data-id="element-617">
            AI Allocation Preferences
          </h2>
          <div className="space-y-4" data-id="element-618">
            <div className="flex items-center justify-between p-3 bg-white/[0.02] rounded-lg border border-white/5" data-id="element-619">
              <div data-id="element-620">
                <h3 className="text-white font-medium text-sm" data-id="element-621">
                  Auto-assign Verified Volunteers
                </h3>
                <p className="text-[var(--muted)] text-xs mt-0.5" data-id="element-622">
                  Automatically place volunteers once documents are verified.
                </p>
              </div>
              <div className="w-10 h-5 bg-[var(--accent)] rounded-full relative cursor-pointer" data-id="element-623">
                <div className="absolute right-1 top-1 w-3 h-3 bg-black rounded-full" data-id="element-624" />
              </div>
            </div>
            <div className="flex items-center justify-between p-3 bg-white/[0.02] rounded-lg border border-white/5" data-id="element-625">
              <div data-id="element-626">
                <h3 className="text-white font-medium text-sm" data-id="element-627">
                  Prioritize Returning Staff
                </h3>
                <p className="text-[var(--muted)] text-xs mt-0.5" data-id="element-628">
                  Give preference to volunteers who worked previous events.
                </p>
              </div>
              <div className="w-10 h-5 bg-[var(--accent)] rounded-full relative cursor-pointer" data-id="element-629">
                <div className="absolute right-1 top-1 w-3 h-3 bg-black rounded-full" data-id="element-630" />
              </div>
            </div>
          </div>
        </section>

        <div className="flex justify-end" data-id="element-631">
          <button className="bg-[var(--accent)] hover:bg-[#b3e622] text-black px-6 py-2 rounded-md font-semibold text-sm transition-colors" data-id="element-632">
            Save Changes
          </button>
        </div>
      </div>
    </motion.div>;
}